export const SLP_REQUESTS_REQUEST = "SLP_REQUESTS_REQUEST";
export const SLP_REQUESTS_SUCCESS = "SLP_REQUESTS_SUCCESS";
export const SLP_REQUESTS_FAILURE = "SLP_REQUESTS_FAILURE";

export const PLA_USER_LIST_REQUEST = "PLA_USER_LIST_REQUEST";
export const PLA_USER_LIST_SUCCESS = "PLA_USER_LIST_SUCCESS";
export const PLA_USER_LIST_FAILURE = "PLA_USER_LIST_FAILURE";

export const SLP_REQUESTS_PDF_REQUEST = "SLP_REQUESTS_PDF_REQUEST";
export const SLP_REQUESTS_PDF_SUCCESS = "SLP_REQUESTS_PDF_SUCCESS";
export const SLP_REQUESTS_PDF_FAILURE = "SLP_REQUESTS_PDF_FAILURE";

export const UPDATE_SLP_CONTACT_PROGRESS_REQUEST =
  "UPDATE_SLP_CONTACT_PROGRESS_REQUEST";
export const UPDATE_SLP_CONTACT_PROGRESS_SUCCESS =
  "UPDATE_SLP_CONTACT_PROGRESS_SUCCESS";
export const UPDATE_SLP_CONTACT_PROGRESS_FAILURE =
  "UPDATE_SLP_CONTACT_PROGRESS_FAILURE";

export const COMPLETED_SLP_LIST_REQUEST = "COMPLETED_SLP_LIST_REQUEST";
export const COMPLETED_SLP_LIST_SUCCESS = "COMPLETED_SLP_LIST_SUCCESS";
export const COMPLETED_SLP_LIST_FAILURE = "COMPLETED_SLP_LIST_FAILURE";

export const COMPLETED_SLP_LIST_PDF_REQUEST = "COMPLETED_SLP_LIST_PDF_REQUEST";
export const COMPLETED_SLP_LIST_PDF_SUCCESS = "COMPLETED_SLP_LIST_PDF_SUCCESS";
export const COMPLETED_SLP_LIST_PDF_FAILURE = "COMPLETED_SLP_LIST_PDF_FAILURE";

export const UPDATE_SLP_PARTICIPATION_REQUEST =
  "UPDATE_SLP_PARTICIPATION_REQUEST";
export const UPDATE_SLP_PARTICIPATION_SUCCESS =
  "UPDATE_SLP_PARTICIPATION_SUCCESS";
export const UPDATE_SLP_PARTICIPATION_FAILURE =
  "UPDATE_SLP_PARTICIPATION_FAILURE";

export const UPDATE_SLP_CONTACT_NOTE_REQUEST =
  "UPDATE_SLP_CONTACT_NOTE_REQUEST";
export const UPDATE_SLP_CONTACT_NOTE_SUCCESS =
  "UPDATE_SLP_CONTACT_NOTE_SUCCESS";
export const UPDATE_SLP_CONTACT_NOTE_FAILURE =
  "UPDATE_SLP_CONTACT_NOTE_FAILURE";

export const VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST =
  "VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST";
export const VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS =
  "VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS";
export const VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE =
  "VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE";
